import BookIcon from '@material-ui/icons/Book'
import StocksByProductsList from './StocksByProductsList'

export default {
    list: StocksByProductsList,
    icon: BookIcon,
}
